export class AuthSessionError extends Error {
  status?: number;
  code?: string | number;
  payload?: unknown;

  constructor(
    message: string,
    options?: {
      status?: number;
      code?: string | number;
      payload?: unknown;
    }
  ) {
    super(message);
    this.name = 'AuthSessionError';
    this.status = options?.status;
    this.code = options?.code;
    this.payload = options?.payload;
  }
}

function includesUnauthorizedText(message?: string) {
  if (!message) {
    return false;
  }

  const normalizedMessage = message.toLowerCase();
  return (
    normalizedMessage.includes('unauthorized')
    || normalizedMessage.includes('authorization')
    || normalizedMessage.includes('forbidden')
    || normalizedMessage.includes('invalid token')
    || normalizedMessage.includes('token expired')
  );
}

export function isUnauthorizedAuthSessionError(error: unknown): boolean {
  if (error instanceof AuthSessionError) {
    return (
      error.status === 401
      || error.status === 403
      || error.code === 'UNAUTHORIZED'
      || error.code === 'FORBIDDEN'
      || includesUnauthorizedText(error.message)
    );
  }

  if (error instanceof Error) {
    return includesUnauthorizedText(error.message);
  }

  return false;
}
